<template>
  <div class="main">
    <div class="steps clearfix text-center">
      <Logo/>
        </div>
    <div class="container">
      <div class="signup-form wizard clearfix">
        <div class="steps clearfix text-center">
          <img src="/assets/img/icons8-upload-to-cloud-100.png" />
        </div>
        <div class="content clearfix">
            <Identity/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Identity from "@/components/steps/Identity.vue";
import Logo from "@/components/ui/Logo.vue";
export default {
    name:"Kyc",
    components:{
        Identity,
        Logo
    }
}
</script>